import styled from "@emotion/styled";
import React from "react";
import { default as ComplianceDocumentIllustration } from "/public/assets/compliance-document-illustration.svg?react";
import Flex from "../../Generic/Flex";

export default function EmptyBox(props: { title: string; message: string }) {
  return (
    <Wrapper>
      <ComplianceDocumentIllustration />
      <Flex direction="column" gap={4} alignItems="center">
        <Title>{props.title}</Title>
        <SubTitle>{props.message}</SubTitle>
      </Flex>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
`;

const Title = styled.h4`
  color: var(--tw-gray-800);
  font-size: 32px;
  font-weight: 800;
  margin: 0;
`;

const SubTitle = styled.p`
  font-size: 18px;
  font-weight: 400;
  margin: 0;
  max-width: 200px;
  text-align: center;
`;
